import { Customer } from '../../types';
import { CustomerCompany } from './types';

export enum ActionTypes {
    OpenEditModal = '[customer/company] OPEN_EDIT_MODAL',
    CloseEditModal = '[customers/company] CLOSE_EDIT_MODAL',
    EditCustomerCompany = '[customer/company] EDIT_CUSTOMER_COMPANY',
    FetchEditCustomerCompanyResponse = '[customer/company] FETCH_EDIT_CUSTOMER_COMPANY_RESPONSE',
}

export interface OpenEditModal {
    type: ActionTypes.OpenEditModal;
}

export interface CloseEditModal {
    type: ActionTypes.CloseEditModal;
}

export interface EditCustomerCompany {
    type: ActionTypes.EditCustomerCompany;
    payload: {
        accountId: string;
        id: string;
        company: CustomerCompany;
    };
}

export interface FetchEditCustomerCompanyResponse {
    type: ActionTypes.FetchEditCustomerCompanyResponse;
    payload: {
        customer: Customer;
    };
    meta: {
        cause: EditCustomerCompany;
    };
}

export function openEditModal() {
    return {
        type: ActionTypes.OpenEditModal,
    };
}

export function closeEditModal() {
    return {
        type: ActionTypes.CloseEditModal,
    };
}

export function editCustomerCompany(
    accountId: string,
    id: string,
    company: CustomerCompany
): EditCustomerCompany {
    return {
        type: ActionTypes.EditCustomerCompany,
        payload: {
            accountId,
            id,
            company,
        },
    };
}

export type Actions =
    | OpenEditModal
    | CloseEditModal
    | EditCustomerCompany
    | FetchEditCustomerCompanyResponse;
